import { formatPrice } from '@moonpig/web-core-utils'
import { Variant } from '@moonpig/web-shared-products'

export const calculatePriceDifference = (
  variant: Pick<Variant, 'key' | 'price'>,
  selectedVariant: Pick<Variant, 'key' | 'price'>,
  language: string,
) => {
  let displayAmount = variant.price.centAmount
  let prefix = ''

  if (selectedVariant.key !== variant.key) {
    displayAmount -= selectedVariant.price.centAmount
    prefix = Math.sign(displayAmount) === -1 ? '- ' : '+ '
  }

  const formattedDisplayAmount = formatPrice(
    Math.abs(displayAmount),
    variant.price.fractionDigits,
    variant.price.currencyCode,
    1,
    language,
  )

  return `${prefix}${formattedDisplayAmount}`
}
